import * as constants from '../constants/CONSTANT';

const QuoteDocumentApi = {
  async downloadQuoteDocument(quoteId, action = 'customer quote', documentType = 'html') {
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(
        `${constants.API_BASE_URL}/api/quotedocument/${quoteId}?action=${encodeURIComponent(action)}&document_type=${encodeURIComponent(documentType)}`,
        {
          method: 'GET',
          headers: {
            Authorization: token,
          },
        }
      );

      if (!response.ok) {
        // Try to get error message, but handle case where response might not be JSON
        let errorMessage = 'Failed to download document';
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch (e) {
          // If response is not JSON, try to get text
          try {
            const errorText = await response.text();
            errorMessage = errorText || errorMessage;
          } catch (e2) {
            // Use default message
          }
        }
        throw new Error(errorMessage);
      }

      // Get filename from Content-Disposition header or use default
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = `Quote_${quoteId}_${new Date().toISOString().split('T')[0]}.pdf`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      // Get content type
      const contentType = response.headers.get('Content-Type') || 'application/pdf';

      // Get blob
      const blob = await response.blob();
      if (!blob || blob.size === 0) {
        throw new Error('Download failed: received empty file. The generated PDF may be empty.');
      }

      // Use blob URL for download so browser gets correct binary content
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      link.click();

      URL.revokeObjectURL(blobUrl);

      return { success: true, filename, contentType };
    } catch (error) {
      console.error('Error downloading quote document:', error);
      throw error;
    }
  },
};

export default QuoteDocumentApi;
